import { render, staticRenderFns } from "./winning_record.vue?vue&type=template&id=5713a3c6&scoped=true"
import script from "./winning_record.vue?vue&type=script&lang=js"
export * from "./winning_record.vue?vue&type=script&lang=js"
import style0 from "./winning_record.vue?vue&type=style&index=0&id=5713a3c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5713a3c6",
  null
  
)

export default component.exports